import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
  import { useCourseTakeStore } from '@/stores/trainings/courseTake';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseProgress',
  setup(__props) {

  const courseTake = useCourseTakeStore();
  const { completedPercent } = storeToRefs(courseTake);

return { __sfc: true,courseTake, completedPercent }
}

})